<template>
  <el-dialog
    class="import-dialog"
    :append-to-body="true"
    :visible="dialogShow"
    title="批量导入"
    width="640px"
    :before-close="handleClose"
  >
    <import-form
      ref="outform"
      @submit="submit"
    ></import-form>
    <!--
      后端逐行处理，整份文件读完就是 code 200，哪怕每行都失败，
      所以导入成败看 failed 而不是 code。只有失败行才需要摊开给用户看。
      -->
    <div
      v-if="result"
      class="import-result"
    >
      <el-alert
        type="warning"
        :closable="false"
        show-icon
        :title="`共 ${result.total} 行，成功导入 ${result.success} 条，失败 ${result.failed} 条`"
      ></el-alert>
      <el-table
        :data="result.failures"
        size="mini"
        max-height="240"
        border
      >
        <el-table-column
          prop="row"
          label="行号"
          width="70"
        ></el-table-column>
        <el-table-column
          v-if="hasUserName"
          prop="userName"
          label="客户姓名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="失败原因"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        :loading="loading"
        type="primary"
        @click.stop="doSubmit"
      >确认并发送通知</el-button>
    </div>
  </el-dialog>
</template>

<script>

import importForm from "./importForm";
export default {
    name: "importDialog",
    components: {
      importForm
    },
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
    },
  data() {
    return {
      title: '批量导入',
      loading: false,
      // 仅在有失败行时留存，用于展示明细
      result: null,
    }
  },
  computed: {
    hasUserName() {
      const failures = (this.result && this.result.failures) || [];
      return failures.some(item => item.userName);
    },
  },
    methods: {
        handleClose() {
          this.$emit('close');
          this.result = null;
          this.$refs.outform.selfClear();
        },
        doSubmit(){
            this.$refs.outform.selfValidate();
        },
      // 逐行统计在 code 200 和 500 上都可能出现：后端每行一个独立事务，
      // 文件级失败之前成功的行照样入库。没有统计字段的（网络错误）直接忽略。
      applyResult(data){
        if (!data || typeof data.success !== 'number') {
          return;
        }
        // 有真入库的就刷列表，哪怕这次整体是失败的
        if (data.success > 0) {
          this.$emit('success');
        }
        // 留着弹窗让用户对着行号改表格，改完可以直接重传
        if (data.failed > 0) {
          this.result = data;
        }
      },
      submit(form){
        // 上传
        this.loading = true;
        this.result = null;
        let urls = [];
        for (let i = 0; i < form.fileList.length; i++) {
          urls.push(form.fileList[i].url);
        }
        // let params = ;
        return this.$http({
          url: '/wx/manage/authorization/batchCreate',
          method: 'post',
          data: urls
        }).then((data) => {
          this.applyResult(data);
          // code 必须一起判：拦截器对 401 是 resolve 不 reject（ajax.js:82 把 401 排除在外），
          // 只看 !this.result 会在 token 失效时一边跳登录页一边弹"成功导入 0 条"
          if (data && data.code === 200 && !this.result) {
            this.$message({
              type: 'success',
              message: `成功导入 ${data.success || 0} 条`,
            });
            this.handleClose();
          }
        }).catch((err) => {
          // 文件级失败（参数为空、格式不对、下载失败）走这里，后端 msg 已由响应拦截器弹出。
          // 但失败前可能已经导入了若干行——后端每行独立事务，不会被后面的失败带走——
          // 所以这里同样要把统计摊开，否则用户只看到"数据读取失败"，
          // 不知道库里其实已经进了几条。网络错误没有统计字段，applyResult 会跳过。
          this.applyResult(err);
        }).then(() => {
          this.loading = false;
          // 这一份已经提交过了，不清的话下次选文件是追加而不是替换，
          // 已成功的行会被再导一遍（失败重传时尤其容易撞上）
          this.$refs.outform.clearFiles();
        })
      }
    },
}
</script>
<style lang="scss">
.import-dialog {
  .sidebar-content {
    text-align: center;
  }
  .el-dialog__header {
    background-color: #F8F8F8;
    padding-bottom: 20px;
  }
  .dialog-footer {
    text-align: center;
  }
  .el-dialog__body {
    text-align: center;
  }
  // el-dialog__body 整体居中，结果明细要按正常阅读方向左对齐
  .import-result {
    margin-top: 16px;
    text-align: left;
  }
}
</style>
